import defaultReducer from "./defaultReducer";

export default defaultReducer('FETCH_MACHINE', []);